import DashboardPage from "../../../../components/DashboardPage";
import BottomView from "./bottom-view";
import { metadata } from "./meta";
import UpperArea from "./top-view";

const Content = () => {
  return (
    <DashboardPage meta={metadata} layout="stacked">
      <UpperArea />
      <BottomView />
    </DashboardPage>
  );
};

export default Content;
